var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { CFBaseModalVeilTokens } from '@connectrn/ds-ui-base';
import { commonAttrs } from '../../utils';
import { CFModalVeilElements } from './ModalVeil.styles';
export const CFModalVeil = (_a) => {
    var { active, alternateTheme, onClick, visible = true } = _a, rest = __rest(_a, ["active", "alternateTheme", "onClick", "visible"]);
    const { Hitspace, Root } = CFModalVeilElements;
    const onClickVeil = (event) => {
        if (onClick)
            onClick(event);
    };
    return (React.createElement(CSSTransition, { in: active, timeout: CFBaseModalVeilTokens.TRANSITION_DURATION }, (state) => (React.createElement(Root, Object.assign({ alternateTheme: alternateTheme, transitionState: state, visible: visible }, commonAttrs(rest)),
        React.createElement(Hitspace, { onClick: onClickVeil })))));
};
